import styled from "styled-components";

// design 1 tab and tile cards

export const TabAndTileVerticalCardsContainer = styled.div`
    display: flex;
    padding: 20px;
    width:100%;
    display: flex;
    flex-direction: column;
    @media(min-width: 768px){
        padding: 35px;
    }
    @media(min-width: 1024px){
        padding: 50px;
    }
`;

export const TabAndTileVerticalCardRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10%;
    margin-top: 20px;
    @media(min-width: 768px){
        margin-top: 35px;
    }
    @media(min-width: 1024px){
        margin-top: 50px;
    }
`

export const TabAndTileVerticalCard = styled.a`
    height: 201px;
    width: ${props => props?.itemsinrow === 1 ? '90%' : `${80 / props?.itemsinrow}%`};
    background: linear-gradient(90deg, #2B2929 80.67%, rgba(0, 0, 0, 0.3));    
    border: 2px solid #FFFFFF;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    padding-left: 41px;
    text-decoration: none;
    overflow: hidden;
    transition: transform 0.5s ease-in-out;
    &:hover {
        transform: scale(1.05);
    }
    @media (max-width: 1296px),(max-height: 1296px) {
        height: 181px;
        padding-left: 30px;
    }
    @media (max-width: 820px), (max-height: 1020px) {
        height: 141px;
        padding-left: 20px;
    }
    @media (max-width: 720px), (max-height: 920px) {
        height: 121px;
        padding-left: 12px;
    }
    @media (max-width: 520px) {
        height: 91px;
        padding-left: 12px;
    }
`;

export const TabAndTileVerticalDetails = styled.div`
    width: 60%; 
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const TileTitleVerticalFirstPart = styled.div`
    font-family: 'Great Vibes';
    font-weight: 400;
    font-size: 34px;
    line-height: 45px;
    @media (max-width: 1296px), (max-height: 1296px) {
        font-size: 27px;
        line-height: 32px;
    }
    @media (max-width: 820px), (max-height: 1020px) {
        font-size: 24px;
        line-height: 30px;
    }
    @media (max-width: 720px), (max-height: 920px) {
        font-size: 18px;
        line-height: 22px;
    }
    @media (max-width: 520px) {
        font-size: 14px;
        line-height: 17px;
    }
`;

export const TileTitleVerticalSecondPart = styled.div`
    font-family: 'Cabin Sketch';
    font-weight: 700;
    font-size: 45px;
    line-height: 45px;
    text-transform: uppercase;
    @media (max-width: 1296px), (max-height: 1296px) {
        font-size: 40px;
        line-height: 40px;
    }
    @media (max-width: 820px), (max-height: 1020px) {
        font-size: 34px;
        line-height: 34px;
    }
    @media (max-width: 720px), (max-height: 920px) {
        font-size: 28px;
        line-height: 28px;
    }
    @media (max-width: 520px) {
        font-size: 17px;
        line-height: 17px;
    }
`;

export const TileVerticalDescription = styled.div`
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    @media (max-width: 1296px), (max-height: 1296px) {
        font-size: 15px;
    }
    @media (max-width: 820px), (max-height: 1020px) {
        font-size: 12px;
    }
    @media (max-width: 520px), (max-height: 920px) {
        display: none;
    }
`;

export const TabAndTileVerticalImg = styled.div`
    width: 20%;
    max-width: 243px;
    background-image: url(${(props) => props.imgURL});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    @media (max-width: 820px) {
        width: 30%;
    }
    @media (max-width: 520px) {
        width: 40%;
    }
`;

// ends here


// design 2 tab And tile cards

export const TabAndTileCardsContainer = styled.div`
    display: flex;
    padding: 20px;
    width:100%;
    display: flex;
    flex-direction: column;
    @media(min-width: 768px){
        padding: 35px;
    }
    @media(min-width: 1024px){
        padding: 50px;
    }
`;

export const TabAndTileCardRow = styled.div`
    display: flex;
    width: 100%;
    gap: ${props => `${10 / props?.itemsRowCount}%`};
    justify-content: center;
    margin-top: 20px; 
    @media(min-width: 768px){
        margin-top: 35px;
    }
    @media(min-width: 1024px){
        margin-top: 50px;
    }
`

export const TabAndTileCard = styled.a`
    flex: ${props => `0 0 ${90 / props?.itemsinrow}%`};
    max-height: 331px;
    aspect-ratio: 1.42;
    text-decoration: none;
    background: ${props => props?.background};
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 21px;
        transition-property: transform;
        transition-duration: .5s;
        transtition-timing-function: ease-in-out;
    &:hover {
        transform: scale(1.1);
    }
    @media (max-width: 1296px) {
        padding: 18px;
    }
    @media (max-width: 820px) {
        padding: 16px;
    }
    @media (max-width: 720px) {
        padding: 12px;
    }
    @media (max-width: 520px) {
        padding: 5px;
    }
`;

export const TileTitleFirstPart = styled.div`
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 35px;
    @media (max-width: 1296px) {
        font-size: 28px;
        line-height: 30px;
    }
    @media (max-width: 820px) {
        font-size: 24px;
        line-height: 26px;
    }
    @media (max-width: 720px) {
        font-size: 18px;
        line-height: 20px;
    }
    @media (max-width: 520px) {
        font-size: 14px;
        line-height: 16px;
    }
`;

export const TileTitleSecondPart = styled.div`
    color: #FFFFFF;
    font-family: 'Cabin Sketch';
    text-transform: uppercase;
    font-weight: 700;
    font-size: 47px;
    line-height: 47px;
    @media (max-width: 1296px) {
        font-size: 35px;
        line-height: 37px;
    }
    @media (max-width: 820px) {
        font-size: 24px;
        line-height: 26px;
    }
    @media (max-width: 720px) {
        font-size: 20px;
        line-height: 22px;
    }
    @media (max-width: 520px) {
        font-size: 16px;
        line-height: 18px;
    }
`;

// ends here